import { createSlice } from "@reduxjs/toolkit";

// Define a type for the slice state
interface UserState {
  user: {
    email: string;
    fullName: string;
    iban: string;
    swift: string;
    accountNumber: number | string;
    sendTo: number | string;
    receiveFrom: number | string;
    aftercharges: number | string;
    fromCurrency: string;
    toCurrency: string;
    exchangeRate: number;
  };
  step: number;
}

// Define the initial state using that type
const initialState: UserState = {
  user: {
    email: "",
    fullName: "",
    iban: "",
    swift: "",
    accountNumber: 0,
    sendTo: 0,
    receiveFrom: 0,
    aftercharges: 0,
    fromCurrency: "",
    toCurrency: "",
    exchangeRate: 0,
  },
  step: 0 || 1 || 2 || 3,
};

export const userSlice = createSlice({
  name: "user",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateFormState: (state, action) => {
      Object.assign(state.user, action.payload);
    },
    updateStep: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.step += action.payload;
    },
  },
});

export const { updateFormState, updateStep } = userSlice.actions;

export const selectUserDetails = (state: any) => state.user.user;
export const selectStep = (state: any) => state.user.step;

export default userSlice.reducer;
